<template>
  <div v-show="showCustomerSupport" class="sidebar__customer-support">
    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="handleSupportClick" tile block v-bind="attrs" v-on="on" elevation="0">
          <v-icon color="grey" size="26">
            mdi-frequently-asked-questions
          </v-icon>
        </v-btn>
      </template>
      {{ supportLabel }}
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'UserSupport',

  computed: {
    supportLabel() {
      return this.$t('customer.label.support')
    },
    userRoles() {
      return localStorage.getItem('access_roles')
    },
    showCustomerSupport() {
      return this.userRoles?.includes('ROLE_REAL_ESTATE') || this.userRoles?.includes('ROLE_CUSTOMER')
    }
  },

  methods: {
    handleSupportClick() {
      window.open('https://academy.hauseful.com/migration/pt-br/cursos/suporte-clientes', '_blank')
    },
  }
}
</script>
